import React from "react";

import { NotificationCard } from "./NotificationCard";
import { NotificationListProps } from "./types";

export const NotificationList = React.memo(
  ({ notifications }: NotificationListProps) => (
    <>
      {notifications.map((notification) => (
        <NotificationCard key={notification.id} {...notification} />
      ))}
    </>
  ),
);

NotificationList.displayName = "NotificationList";
